import React from 'react'
import { connect } from 'react-redux'
// import Loading from '../Shared/Loading'
import LoadingBar from '../Shared/LoadingBar'
import { history } from '../../_helpers'
import LoadingCircle from '../Shared/LoadingCircle'
import { examService } from '../../_services/exam.service'
import { toastr } from 'react-redux-toastr'
import moment from 'moment-jalaali'
import paymentStatuses from '../../_constants/paymentStatuses'
import NumberFormat from 'react-number-format'

function formatDateTime(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e, 'YYYY-MM-DD HH:mm:ss')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD  ساعت HH:mm:ss')
    }
  }
}

class MemberPayments extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: true,
      data: []
    }
  }

  componentDidMount = () => {
    LoadingBar(true)

    this.getData()
  }

  getData() {
    if (this.props.user && this.props.user.id) {
      this.setState({ memberId: this.props.user.id, loading: true }, () => {
        let dto = {}
        dto['memberId'] = this.props.user.id
        dto['page'] = 1
        dto['pageSize'] = 100
        examService
          .getPayments(JSON.stringify(dto))
          .then(res => {
            // console.log(res.data)
            var data = res.data
            this.setState({ data: data, loading: false }, () => {
              LoadingBar(false)
            })
          })
          .catch(error => {
            this.handleError(error)
            // history.push('/member/exam')
          })
      })
    } else {
      toastr.warning('صفحه مورد نظر وجود ندارد')
      history.push('/member/')
    }
  }

  handleError(error) {
    this.setState({ loading: false })
    LoadingBar(false)
    // console.log(error);
  }

  render() {
    const { data, loading } = this.state

    return data ? (
      <div className="row">
        <div className="col-md-10 col-md-offset-1">
          <fieldset className="fieldset">
            <legend>سوابق پرداخت</legend>
            {data && data.result && (
              <table className="table table-striped table-hover exam-table text-center table-bordered table-canvas">
                <thead>
                  <tr>
                    <th className="text-center">ردیف</th>
                    <th className="text-center">تاریخ</th>
                    <th className="text-center">مبلغ</th>
                    <th className="text-center">بابت</th>
                    <th className="text-center">وضعیت</th>
                    <th className="text-center">کد رهگیری</th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.result.length > 0 ? (
                    data.result.map((item, index) => (
                      <tr key={'payment-' + item.id + '-' + index}>
                        <td>{index + 1}</td>
                        <td>{formatDateTime(item.createDate)}</td>
                        <td>
                          <NumberFormat
                            thousandSeparator={true}
                            className="numberFa"
                            value={item.amount}
                            displayType="text"
                            suffix=" ریال"
                          />
                        </td>
                        <td>
                          {item.paymentType === 0
                            ? item.currentClass.lesson.name
                            : 'آزمون'}
                        </td>
                        <td>
                          {
                            paymentStatuses.filter(
                              el => el.id === item.paymentStatus
                            )[0].name
                          }
                        </td>
                        <td>{item.referCode}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="7"
                        className="text-center pb-30 pt-30 td-white">
                        موردی برای نمایش وجود ندارد
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </fieldset>
        </div>
      </div>
    ) : (
      <LoadingCircle />
    )
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state
  const { user } = authentication
  return {
    user,
    users
  }
}

const connectedMemberPayments = connect(mapStateToProps)(MemberPayments)
export { connectedMemberPayments as MemberPayments }
